import { forwardRef, type Ref, type SVGProps } from "react";
const IconAirConditioningOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M28 2H4a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2m0 25.5a.5.5 0 0 1-.5.5h-23a.5.5 0 0 1-.5-.5v-23a.5.5 0 0 1 .5-.5h23a.5.5 0 0 1 .5.5z" />
    <path d="M16 8a8 8 0 1 1-8 8 8 8 0 0 1 8-8m0-2a10 10 0 1 0 10 10A10 10 0 0 0 16 6" />
    <path d="M21.83 16.45a1 1 0 0 0-1.38-.28 2.35 2.35 0 0 1-3-.08 4.36 4.36 0 0 0 .41-5.64 1 1 0 0 0-1.66 1.1 2.35 2.35 0 0 1-.08 3 4.36 4.36 0 0 0-5.64-.41 1 1 0 1 0 1.1 1.66 2.35 2.35 0 0 1 3 .08 4.36 4.36 0 0 0-.41 5.64A1 1 0 0 0 15 22a.94.94 0 0 0 .55-.17 1 1 0 0 0 .28-1.38 2.33 2.33 0 0 1 .09-3 4.54 4.54 0 0 0 3 1.26 4.65 4.65 0 0 0 2.59-.85 1 1 0 0 0 .32-1.41M16 17a1 1 0 1 1 1-1 1 1 0 0 1-1 1" />
  </svg>
);
const ForwardRef = forwardRef(IconAirConditioningOutlineSVG);
ForwardRef.displayName = "IconAirConditioningOutline";
export { ForwardRef as IconAirConditioningOutline };
